export default class Utilization {
    static fromData(data) {
        if (!data) {
            return;
        }

        let utilization = new Utilization();

        utilization.data = data.data;
        utilization.metaData = data.metadata;

        Object.seal(utilization);
        return utilization;
    }
}
